import { useContext } from 'react';
import TaskContext from '../provider/context';

const useTaskContext = () => {
  const taskContext = useContext(TaskContext);
  return taskContext;
};

export default useTaskContext;
